/** IDs das origens dos dados da aplicação */
export enum OrigemID {
   DESCONHECIDA = 0,
   CAMPANHA = 1,
   INDICACAO = 2,
   MIDIA_SOCIAL = 3,
   PESQUISA_ORGANICA = 4,
   PROSPECCAO_ATIVA = 5,
   SITE = 6,
   ECOMMERCE = 7,
   OUTRA = 99
}

export namespace OrigemID {
    /** Verifica se é a origem Desconhecida */
    export function isOrigemDesconhecida(id: number): boolean {
        return id === OrigemID.DESCONHECIDA;
    }
    /** Verifica se é a origem Campanha */
    export function isOrigemCampanha(id: number): boolean {
        return id === OrigemID.CAMPANHA;
    }
    /** Verifica se é a origem Indicação */
    export function isOrigemIndicacao(id: number): boolean {
        return id === OrigemID.INDICACAO;
    }
    /** Verifica se é a origem Mídia Social */
    export function isOrigemMidiaSocial(id: number): boolean {
        return id === OrigemID.MIDIA_SOCIAL;
    }
    /** Verifica se é a origem Pesquisa Orgânica */
    export function isOrigemPesquisaOrganica(id: number): boolean {
        return id === OrigemID.PESQUISA_ORGANICA;
    }
    /** Verifica se é a origem Prospecção Ativa */
    export function isOrigemProspeccaoAtiva(id: number): boolean {
        return id === OrigemID.PROSPECCAO_ATIVA;
    }
    /** Verifica se é a origem Site */
    export function isOrigemSite(id: number): boolean {
        return id === OrigemID.SITE;
    }
    /** Verifica se é a origem E-commerce */
    export function isOrigemEcommerce(id: number): boolean {
        return id === OrigemID.ECOMMERCE;
    }
    /** Verifica se é a origem Outra */
    export function isOrigemOutra(id: number): boolean {
        return id === OrigemID.OUTRA;
    }
}
